module.exports = __webpack_public_path__ + "img/链家@2x.0854463a.png";